import { Component, OnDestroy } from '@angular/core';
import {
  AbstractControl,
  ValidationErrors,
  Validators,
  ValidatorFn,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ControlsOf, FormBuilder, FormGroup } from '@ngneat/reactive-forms';
import { Observable, Subject } from 'rxjs';

import { LoginSessionFacadeService } from '@digital-platform/users/services';
// import { filter, takeWhile } from 'rxjs/operators';

interface ResetPassword {
  password: string;
  confirmPassword: string;
}

@Component({
  selector: 'digital-platform-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnDestroy {
  public resetPasswordForm: FormGroup<ControlsOf<ResetPassword>>;
  private destroyed$ = new Subject<void>();
  public errorMsg: string;
  public loading$: Observable<boolean>;

  constructor(
    private formBuilder: FormBuilder,
    private facade: LoginSessionFacadeService,
    private router: Router
  ) {
    this.resetPasswordForm = this.formBuilder.group({
      password: ['', Validators.required],
      confirmPassword: ['', [Validators.required, this.checkPasswords]],
    });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onResetPasswordSubmit() {
    if (this.resetPasswordForm.invalid) {
      this.resetPasswordForm.markAllAsTouched();
      this.resetPasswordForm.updateValueAndValidity();
      return;
    }

    const { password: newPassword } = this.resetPasswordForm.value;

    this.facade.resetPassword(newPassword);
    this.facade.logout('Log in with your new password');
    // this.router.navigate(['/login']);
  }

  errorHandling = (control: string, error: string) =>
    this.resetPasswordForm.touched &&
    this.resetPasswordForm.controls[control].hasError(error);

  checkPasswords: ValidatorFn = (
    group: AbstractControl
  ): ValidationErrors | null => {
    const password = group?.parent?.value?.password;
    const confirmPassword = group.value;
    return password === confirmPassword ? null : { notSame: true };
  };
}
